/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M13.447 5.635a3.41 3.41 0 0 1 2.425-1.005A3.409 3.409 0 0 1 18.3 5.635a.625.625 0 1 1-.885.884 2.232 2.232 0 0 0-3.084 0 .625.625 0 0 1-.883-.884Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.253 3.759a6.016 6.016 0 0 0-8.501 0l-7.976 7.979A6 6 0 0 0 8.018 22a5.964 5.964 0 0 0 4.246-1.754l7.986-7.985a6.026 6.026 0 0 0 0-8.501l.003-.001Zm-1.179 7.323-3.105 3.102a.417.417 0 0 1-.59 0L9.83 8.633a.417.417 0 0 1 0-.59l3.105-3.106a4.334 4.334 0 0 1 7.405 3.077 4.3 4.3 0 0 1-1.265 3.068Z"
})), "0 0 24 24", "Pharmacy");